import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

import { dispatcherSlice, MultiloadFlowMode } from '../dispatcher.slice';
import { MultiloadAssignmentSelection } from './MultiloadAssignmentSelection';
import { MultiloadIcon } from './MultiloadIcon';

const modeConfig = {
  'assign-trip': {
    heading: 'Do you want to multi-load?',
    nextText: (n: number) =>
      n < 2 ? 'Assign without multi-loading' : 'Multi-load with selected trips',
    isNextDisabled: (_n: number) => false,
    cancelLabel: 'Cancel',
  },
  'edit-trip-multi-load': {
    heading: null,
    nextText: (n: number) =>
      n < 2 ? 'Unmulti-load these trips' : 'Multi-load with selected trips',
    isNextDisabled: (_n: number) => false,
    cancelLabel: 'Cancel',
  },
  'create-assigned-trip-multi-load': {
    heading: 'Do you want to multi-load?',
    nextText: (_n: number) => 'Multi-load with selected trips',
    isNextDisabled: (n: number) => n < 2,
    cancelLabel: 'Cancel',
  },
  'add-to-existing-multi-load': {
    heading: 'Add trip to existing multi-load?',
    nextText: (_n: number) => 'Add to multi-load',
    isNextDisabled: (_n: number) => false,
    cancelLabel: 'Cancel',
  },
  'assign-to-existing-multi-load': {
    heading: 'Add trip to existing multi-load?',
    nextText: (_n: number) => 'Assign and multi-load',
    isNextDisabled: (_n: number) => false,
    cancelLabel: 'Assign without multi-loading',
  },
} satisfies Record<
  MultiloadFlowMode,
  {
    heading: string | null;
    nextText: (n: number) => string;
    isNextDisabled: (n: number) => boolean;
    cancelLabel: string;
  }
>;

export function MultiloadSelectionStep({
  onNext,
  onAssignWithoutMultiload,
}: {
  onNext: () => void;
  onAssignWithoutMultiload?: () => void;
}) {
  const dispatch = useAppDispatch();
  const { selectedTripIdsToMultiload, mode } = useAppSelector(
    (state) => state.dispatcher.multiloadAssignmentFlow
  );
  const config = modeConfig[mode];
  const count = selectedTripIdsToMultiload.length;
  return (
    <div className="flex max-w-md flex-col gap-6 p-2">
      <div className="mt-3 flex justify-center">
        <MultiloadIcon />
      </div>
      {config.heading && (
        <h2 className="-mt-2 text-center text-xl">{config.heading}</h2>
      )}
      <div className="max-h-[50vh] overflow-auto">
        <MultiloadAssignmentSelection />
      </div>
      <div className="flex gap-4">
        <Button
          className="flex-grow"
          onClick={
            mode === 'assign-to-existing-multi-load'
              ? () => onAssignWithoutMultiload?.()
              : () =>
                  dispatch(dispatcherSlice.actions.onMultiloadFlowCancel())
          }
        >
          {config.cancelLabel}
        </Button>
        <Button
          className="flex-grow"
          variant="primary"
          onClick={onNext}
          disabled={config.isNextDisabled(count)}
        >
          {config.nextText(count)}
        </Button>
      </div>
    </div>
  );
}
